import { Card } from "antd";
import { FaClinicMedical, FaEnvelope, FaMapMarkerAlt, FaPhone, FaPlus } from "react-icons/fa";
import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io";
import { useLanguage } from '../../context/LanguageContext';

export default function CliniSelect({ clinics, onSelect, selectedClinic }) {
    const { t } = useLanguage();
    console.log(clinics);
    
    if(clinics.length === 0) {
        return(
            <Card className="border-2 border-dashed border-placeHolder bg-cardColor rounded-xl">
                <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                        <FaClinicMedical className="text-3xl text-placeHolder" />
                    </div>
                    <h3 className="text-lg font-medium text-textPrimary mb-2">
                        {t('booking.clinicSelect.noClinic')}
                    </h3>
                    <p className="text-placeHolder text-sm mb-4 max-w-md">
                        {t('booking.clinicSelect.noClinicDescription')}
                    </p>
                    <div className="flex items-center gap-2 text-placeHolder text-xs">
                        <FaPlus className="text-sm" />
                        <span>{t('booking.clinicSelect.willAppear')}</span>
                    </div>
                </div>
            </Card>
        )
    }
    
    return (
        <div className="space-y-3">
            {/* Header */}
            <h2 className="text-lg font-semibold text-textPrimary flex items-center gap-2">
                <FaClinicMedical className="text-primary text-xl" />
                {t('booking.clinicSelect.title')}
            </h2>

            {/* Clinic Cards */}
            <div className="grid grid-cols-1 gap-3">
                {clinics.map((clinic) => {
                    const isSelected = selectedClinic?.id === clinic.id;
                    return (
                        <Card
                            key={clinic.id}
                            onClick={() => onSelect(clinic)}
                            className={`border transition-all bg-cardColor text-textPrimary rounded-xl ${
                                isSelected
                                    ? "border-textPrimary bg-primary text-white"
                                    : "border-placeHolder"
                            }`}
                            bodyStyle={{ padding: "12px" }}
                        >
                            <div className="flex flex-col gap-2">
                                {/* Top Row: Radio Button and Clinic Name */}
                                <div className="flex items-center gap-2">
                                    {isSelected ? (
                                        <IoMdRadioButtonOn className="text-xl text-secondary" />
                                    ) : (
                                        <IoMdRadioButtonOff className="text-xl text-textPrimary" />
                                    )}
                                    <h3 className="text-base font-medium">{clinic.name}</h3>
                                </div>

                                {/* Address */}
                                <div
                                    className={`flex items-center gap-2 text-sm ${
                                        isSelected ? "text-white" : "text-placeHolder"
                                    }`}
                                >
                                    <FaMapMarkerAlt className="text-base" />
                                    <span>{clinic.detailedAddress}</span>
                                </div>

                                {/* Contact Info (Email and Phone) */}
                                <div className="flex justify-between items-center text-sm flex-wrap gap-y-2">
                                    <div
                                        className={`flex items-center gap-2 ${
                                            isSelected ? "text-white" : "text-placeHolder"
                                        }`}
                                    >
                                        <FaEnvelope className="text-base" />
                                        <span>{clinic?.contactEmail}</span>
                                    </div>
                                    <div
                                        className={`flex items-center gap-2 ${
                                            isSelected ? "text-white" : "text-placeHolder"
                                        }`}
                                    >
                                        <FaPhone className="text-base" />
                                        <span>{clinic.contactPhone}</span>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    );
                })}
            </div>
        </div>
    );
}